import type { ClientContext } from '~/services/contextClient';
import type { AiMessageVettingAgentsClientInterface } from './aiMessageVettingAgentsClient.types';
import CorporateAiMessageVettingAgentsClient from './corporateAiMessageVettingAgentsClient';

export default class AiMessageVettingAgentsClientFactory {
    static createClient(context: ClientContext): AiMessageVettingAgentsClientInterface {
        if (!context.orgUnitId && !context.groupId) {
            return new CorporateAiMessageVettingAgentsClient(context.teamId);
        }

        throw new Error('AI Message Vetting Agents only supports corporate context');
    }
}
